import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

/**
 * Shared authentication card component
 * Provides consistent styling for all auth screens
 */
export function AuthCard({ icon, headline, supporting, children, footer }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: "#F6F8FC" }}>
      <Card 
        className="w-full bg-white"
        style={{
          maxWidth: "460px",
          borderRadius: "16px",
          border: "1px solid #e5e9f2",
        }}
      >
        <CardHeader className="space-y-4" style={{ padding: "32px 32px 24px 32px" }}>
          {/* Theo Icon */}
          {icon && (
            <div className="flex justify-center">
              <img 
                src={icon} 
                alt="Theo" 
                style={{ 
                  width: "32px", 
                  height: "32px"
                }}
              />
            </div>
          )}
          
          {/* Headline */}
          <div className="space-y-2 text-center">
            <h1 
              className="font-semibold tracking-tight leading-tight"
              style={{
                color: "#0B1220",
                fontSize: "24px",
              }}
            >
              {headline}
            </h1>
            
            {/* Supporting text */}
            {supporting && (
              <p 
                className="leading-relaxed"
                style={{
                  color: "#64748B",
                  fontSize: "14px",
                }}
              >
                {supporting}
              </p>
            )}
          </div>
        </CardHeader>
        
        <CardContent style={{ padding: "0 32px 32px 32px" }}>
          <div className="space-y-6">
            {children}
          </div>
          
          {footer && (
            <div className="mt-6">
              {footer}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
